import { otmm } from '../../otmm/apis/otmm';

export default async (metadataFields) => {
  const results = await otmm.get(`/metadatafields?ids=${metadataFields}`);
  return results.data.metadata_fields_resource.metadata_field_list;
};
